import React, { useState } from "react";
import { Sparkles, HelpCircle, Upload, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const discoverItems = [
  {
    link: "/GoldDomain",
    title: "Know it",
    description: "Invest in premium, high-demand domains for high returns.",
    buttonText: "Discover .Gold",
    icon: Sparkles,

    delay: 0,
  },
  {
    link: "/marketplace-help",
    title: "Get Help",
    description:
      "Rely on our expertise to get the best price for your domains.",
    buttonText: "Get Help",
    icon: HelpCircle,

    delay: 250,
  },
  {
    link: "/post-dot-gold-domain",
    title: "Post Domain",
    description:
      "Quickly post your domains and reach a wide audience of buyers.",
    buttonText: "List .Gold",
    icon: Upload,

    delay: 500,
  },
];

const Discover = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <div className="discover-part py-16 bg-[#eef4f9] ">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="pb-12 text-center">
          <h2 className="title">
            Discover Your <span className="text-pent">Domain's Value</span>
          </h2>
          <p className="mx-auto text-base md:text-lg text-gray-600 mt-4 max-w-2xl">
            We determine and maximize your domain's true value for informed
            decisions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {discoverItems.map((item, index) => {
            const IconComponent = item.icon;
            const isHovered = hoveredIndex === index;

            return (
              <div
                key={index}
                className="group relative"
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                style={{
                  animation: `fadeInUp 0.6s ease-out ${item.delay}ms both`,
                }}
              >
                <div
                  className={`
                  relative overflow-hidden rounded-2xl bg-gold-gradient border-2 border-gray-100
                  transition-all duration-500 ease-out cursor-default
                  ${
                    isHovered
                      ? "shadow-2xl scale-105 -translate-y-2"
                      : "shadow-lg hover:shadow-xl"
                  }
                `}
                >
                  {/* Gradient Background on Hover */}
                  <div
                    className={`
                    absolute inset-0 bg-gradient-to-br opacity-0 
                    transition-opacity duration-500
                    ${isHovered ? "opacity-100" : ""}
                  `}
                  />

                  {/* Content */}
                  <div className="relative z-10 p-8">
                    {/* Icon */}
                    <div
                      className={`
                      inline-flex p-4 rounded-xl mb-6
                      transition-all duration-500
                    icon-process
                    `}
                    >
                      <IconComponent
                        className={`
                    
                          ${isHovered ? "text-[#101c4c]" : "text-[#101c4c]"}
                        `}
                      />
                    </div>

                    {/* Title */}
                    <h3
                      className={`
                      text-2xl md:text-3xl font-bold mb-3
                      transition-colors duration-500 !text-[#101c4c]

                    `}
                    >
                      {item.title}
                    </h3>

                    {/* Description */}
                    <p
                      className={`
                      text-base leading-relaxed mb-6
                      transition-colors duration-500
             
                    `}
                    >
                      {item.description}
                    </p>

                    {/* CTA Button */}
                    <Link to={item.link}>
                      <div
                        className={`
                      inline-flex items-center gap-2 font-semibold
                      transition-all duration-500
                      ${isHovered ? "text-[#101c4c]" : "text-[#101c4c]"}
                    `}
                      >
                        <span>{item.buttonText}</span>
                        <ArrowRight
                          className={`
                        w-5 h-5 transition-transform duration-500
                        ${isHovered ? "translate-x-2" : ""}
                      `}
                        />
                      </div>
                    </Link>
                  </div>

                  {/* Decorative Elements */}
                  <div
                    className={`
                    absolute -bottom-16 -right-16 w-32 h-32 rounded-full
                    bg-gradient-to-br  opacity-20 blur-2xl
                    transition-all duration-500
                    ${isHovered ? "scale-150 opacity-30" : ""}
                  `}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default Discover;
